<script>
import AMapLoader from '@amap/amap-jsapi-loader';
import {Message} from "element-ui";
import {addDevice} from "@/api";
window._AMapSecurityConfig = {
  // 设置安全密钥 停用
  // securityJsCode: "26772ae6306fd39f03d74fb10e9eeb65",
  securityJsCode: "",
};
export default {
  name: 'AMapSearchDialog',
  data() {
    return {
      visible: false,
      device: null,
      map: null,
      placeSearch: null,
      searchKeyword: '',
      dataForm :  {},
      auto : null,
      markers: [],
      lnglat: null,
    }
  },
  mounted() {

  },
  destroyed() {
    this.clearMap()
  },

  methods: {
    open(device) {
      if (!device) {
        Message.error('设备信息获取失败')
        return;
      }
      this.device = device;
      this.dataForm = {
        id: this.device.id,
        name: this.device.name,
        longitude: this.device.longitude,
        latitude: this.device.latitude,
        address: this.device.address,
        provinceCode : this.device.provinceCode,
        cityCode : this.device.cityCode,
        districtCode : this.device.districtCode,

      }
      this.visible = true;
      this.initMap();

    },
    close() {
      this.visible = false;
    },

    // 地图初始化
    initMap() {
      let lng =  this.device.longitude || 113.011422
      let lat =  this.device.latitude || 23.126558
      AMapLoader.load({
        // key: 'ae1e8b12e899353a7e05e9fa26587e8e',
        key: '', // 当前已停用
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.AutoComplete", "AMap.PlaceSearch", "AMap.Geocoder"],
      })
          .then((AMap) => {
            this.map = new AMap.Map('map-container', {
              zoom: 15,
              center: [parseFloat(lng), parseFloat(lat)],
              resizeEnable: true,
            });
            // 检查是否存在 mapMark.png 图片

            const marker = new AMap.Marker({
              position: [parseFloat(lng), parseFloat(lat)],
              title: this.device.name || '运营中心',
              anchor: 'center',
              icon: new AMap.Icon({
                image: require('@/assets/mapMark.png'),
                imageSize: new AMap.Size(32, 32),
                anchor: 'center'
              })
            });
            this.map.add(marker);
            // 关键字查询
            this.searchMap();
            // 监听鼠标点击事件
            this.map.on("click", this.clickMapHandler);
          })
          .catch((e) => {
          });
    },
    // 关键字查询
    searchMap() {
      // 搜索框自动完成类
      this.auto = new AMap.AutoComplete({
        input: "tipinput", // 使用联想输入的input的id
      });
      //构造地点查询类
      this.placeSearch = new AMap.PlaceSearch({
        map: this.map,
        panel: "search-result",
      });
      // 当选中某条搜索记录时触发
      this.auto.on("select", this.selectSite);
      // 当点击搜索结果面板中的结果时触发
      this.placeSearch.on("selectChanged", (e) => {
        const poiData = e.selected.data;
        console.log('poiData:', poiData)
        // 使用 $set 确保响应式更新
        this.$set(this.dataForm, "longitude", poiData.location.lng);
        this.$set(this.dataForm, "latitude", poiData.location.lat);
        this.$set(this.dataForm, "address", poiData.address);
        this.$set(this.dataForm, "districtCode", poiData.adcode);

      });
    },
    //选中查询出的记录
    selectSite(e) {
      if (e.poi.location) {
        this.lnglat = [e.poi.location.lng, e.poi.location.lat];
        this.placeSearch.setCity(e.poi.adcode);
        this.placeSearch.search(e.poi.name); //关键字查询
        let geocoder = new AMap.Geocoder({});
        let that = this;
        that.$set(that.dataForm, "longitude", e.poi.location.lng);
        that.$set(that.dataForm, "latitude", e.poi.location.lat);
        geocoder.getAddress(this.lnglat, function (status, result) {
          if (status === "complete" && result.regeocode) {
            console.log('regeocode:', result.regeocode)
            that.$set(that.dataForm, "address", result.regeocode.formattedAddress);
            that.$set(that.dataForm, "districtCode", result.regeocode.addressComponent.adcode);
          } else {
          }
        });
      } else {
        this.$message.error("查询地址失败，请重新输入地址");
      }
    },
    // 点击地图事件获取经纬度，并添加标记
    clickMapHandler(e) {
      console.log('clickMapHandler:', e)
      const lng = e.lnglat.lng;
      const lat = e.lnglat.lat;
      this.lnglat = [lng, lat];

      // 使用 $set 确保响应式更新
      this.$set(this.dataForm, "longitude", lng);
      this.$set(this.dataForm, "latitude", lat);
      this.lnglat = [e.lnglat.lng, e.lnglat.lat];
      this.setMarker(this.lnglat);
      // 点击地图上的位置，根据经纬度转换成详细地址
      let geocoder = new AMap.Geocoder({});
      let that = this;
      geocoder.getAddress(this.lnglat, function (status, result) {
        console.log('geocoder:', result)
        if (status === "complete" && result.regeocode) {
          that.$set(that.dataForm, "address", result.regeocode.formattedAddress);
          that.$set(that.dataForm, "districtCode", result.regeocode.addressComponent.adcode);
        } else {
        }
      });
    },
    //  添加标记
    setMarker(lnglat) {
      this.removeMarker();
      const marker = new AMap.Marker({
        position: lnglat,
        title: this.device.name || '运营中心',
        anchor: 'center',
        icon: new AMap.Icon({
          image: require('@/assets/mapMark.png'),
          imageSize: new AMap.Size(32, 32),
          anchor: 'center'
        })
      });
      marker.setMap(this.map);
      this.markers.push(marker);
    },
    // 删除之前后的标记点
    removeMarker() {
      if (this.markers) {
        this.map.remove(this.markers);
      }
    },
    clearMap() {
      if (this.map) {
        this.map.destroy();
        this.map = null;
        this.placeSearch = null;
      }
    },

    async submitLocation (){
      if (!this.dataForm.longitude || !this.dataForm.latitude){
        Message.error("请选择位置")
        return
      }
      const param = {
        ...this.device,
        ...this.dataForm
      }
      console.log('confirmLocation:', param)
      const res = await addDevice(param)
      if (res && res.code === "0000"){
        this.$message.success('保存成功')
        this.visible = false
        this.clearMap()
        this.$emit('refresh')
      }
    },
  },
}


</script>

<template>
  <el-dialog
      title="地图标点"
      :visible.sync="visible"
      width="800px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
  >
    <div class="map-dialog-container">
      <div class="search-box">
        <div class="search-input-wrapper">
          <input
              v-model="searchKeyword"
              placeholder="请输入地点名称"
              id="tipinput"
              class="search-input"
          />
        </div>
      </div>
      <div class="map-content">
        <div id="map-container" style="width: 100%; height: 400px; border: 1px solid #ddd;"></div>
        <div id="search-result"
             style="position: absolute; top: 50px; right: 10px; width: 200px; max-height: 300px; overflow-y: auto; background-color: white; border: 1px solid #ddd; z-index: 39999"></div>
      </div>
      <div class="position-info">
        <p>经度: {{ dataForm.longitude || '-'}}</p>
        <p>纬度: {{ dataForm.latitude  || '-'}}</p>
        <p>地址: {{ dataForm.address  || '-'}}</p>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submitLocation">确定</el-button>
    </div>
  </el-dialog>
</template>

<style scoped>
.map-dialog-container {
  padding: 10px;
}

.search-box {
  margin-bottom: 10px;
}

.map-content {
  position: relative;
  margin-bottom: 10px;
  height: 400px;
}

.position-info {
  margin-top: 10px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.position-info p {
  margin: 5px 0;
}

.search-input-wrapper {
  display: flex;
  align-items: center;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 15px;
  transition: border-color 0.2s;
  position: relative;
  z-index: 1000;
}

.search-input-wrapper:hover {
  border-color: #c0c4cc;
}

.search-input-wrapper:focus-within {
  border-color: #409eff;
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  padding: 12px 0;
  font-size: 14px;
  color: #606266;
}

.search-input::placeholder {
  color: #c0c4cc;
}

.search-button {
  margin-left: 10px;
  border: none;
  background: none;
  padding: 0;
}

</style>
